import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IBaseProps, IProps as ISelectProps, PortalSelectMenu } from '../PortalSelectMenu';
import { IFetchDefault } from 'redux/modules/fetch';
import { IPage } from 'models/common';
import { IUserDropdownItem, IUserDropdownValue, IUserListItem } from 'models/user/userlistitem';
import { PersonItem } from 'components';

type IProps = Omit<IBaseProps, 'formatOptionLabel'> & {
	fetchDefault: IFetchDefault;
	t?: (x: string) => string;
};

interface IState {
	error?: string;
	numberOfItems?: number;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalUserSelect extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.searchUsers = this.searchUsers.bind(this);
		this.formatOption = this.formatOption.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	private formatOption(item: IUserDropdownItem | IUserDropdownValue): JSX.Element {
		return <PersonItem user={item} hasArrow={true} />;
	}

	private searchUsers(search: string): Promise<IUserDropdownItem[]> {
		search = search.trim();
		if (search && search.length > 2) {
			return fetch(
				this.props.fetchDefault.baseAPI +
					'api/User/Search?keyword=' +
					encodeURIComponent(search.trim()) +
					'&currentPage=1&itemsPerPage=20',
				Object.assign({}, this.props.fetchDefault.requestInit, {
					method: 'GET',
				}),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res: IPage<IUserListItem>) => {
							let valueArr: IUserDropdownItem[] = [];
							// add dropdown info
							if (res.items.length) {
								valueArr.push({
									value: {
										name: res.items.length + ' ' + this.props.t('BSPortal_Common_Results').toLowerCase(),
										entityId: '',
									},
									key: '',
									image: null,
									description: '',
									isDisabled: true,
								});
							}
							// add search results
							return (valueArr = [
								...valueArr,
								...res.items.map(
									(user): IUserDropdownItem => ({
										value: {
											picture: user.picture,
											name: user.name,
											entityId: user.entityId,
										},
										key: JSON.parse(user.entityId).id,
										image: user.picture,
										description: user.email,
									}),
								),
							]);
						});
					} else {
						this.setState({
							error: res.statusText,
						});
						return [];
					}
				})
				.catch((error) => {
					this.setState({
						error,
					});
					return [];
				});
		}
	}

	private onChange(ev: any) {
		if (this.props.onChangeAction) {
			this.props.onChangeAction(ev);
		}
	}

	public render() {
		const selectProps: ISelectProps<IUserDropdownValue, string, IUserDropdownItem> = {
			...this.props,
			asyncLoad: this.searchUsers,
			formatOptionLabel: this.formatOption,
			clearAfterSelect: true,
			customDropdownIcon: 'search1',
		};
		return <PortalSelectMenu {...(selectProps as any)} />;
	}
}

export { PortalUserSelect };
